import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Alert } from "../../../../domain/alert/Alert";
import { CareRecipientHouseId } from "../../../../domain/care_recipient/CareRecipientHouseId";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { CareRecipientName } from "../../../../domain/care_recipient/CareRecipientName";
import { CareRecipientWithDataSyncInformation } from "../../../../domain/care_recipient/CareRecipientWithDataSyncInformation";
import { DateObject } from "../../../../domain/fundamental/DateObject";
import { DateTime } from "../../../../domain/fundamental/DateTime";
import { State } from "../../../../state/store";

export default function useAlerts(): UseAlertsReturnType {

    const { alerts, displayAlertsPage, checkedAlertIds } = useSelector((state: State) => state.adminCareRecipient);

    const result = useMemo(() => alerts?.map(
        alert => {
            const careRecipient = CareRecipientWithDataSyncInformation.from(
                CareRecipientId.fromString(alert.careRecipient.id),
                CareRecipientName.fromString(alert.careRecipient.name),
                null,
                CareRecipientHouseId.fromString(alert.careRecipient.dataSyncInformation.houseId),
                null,
                alert.careRecipient.dataSyncInformation.dataSyncPeriod.startTime ? DateTime.fromString(alert.careRecipient.dataSyncInformation.dataSyncPeriod.startTime) : null,
                alert.careRecipient.dataSyncInformation.dataSyncPeriod.endTime ? DateTime.fromString(alert.careRecipient.dataSyncInformation.dataSyncPeriod.endTime) : null,
                null,
                null
            );
            const period = alert.period;
            const newPeriod = period == null ? null : { start: DateObject.fromString(period.start), end: DateObject.fromString(period.end) };
            const newAlert = new Alert(
                alert.alert.category,
                alert.alert.message,
                alert.alert.date,
                alert.alert.id,
                alert.alert.display,
                alert.alert.createdFrom
            );
            return {
                careRecipient: careRecipient,
                period: newPeriod,
                alert: newAlert
            };
        }
    ) ?? null, [alerts]);
    return {
        alerts: result,
        displayAlertsPage: displayAlertsPage,
        checkedAlertIds: checkedAlertIds
    };
}

type UseAlertsReturnType = {
    alerts: {
        careRecipient: CareRecipientWithDataSyncInformation,
        period: { start: DateObject | null, end: DateObject | null } | null,
        alert: Alert
    }[] | null,
    displayAlertsPage: number,
    checkedAlertIds: string[]
}